import Vue from 'vue';
import axios from '@/models/API/axios'
import CoreApp from "../CoreApp.js";
import * as apiUrl from './apiUrl.js';

/**
 * 主要api
 */
class baseApi {
    constructor() {
        this.vm = new Vue()
        this.CoreApp =  new CoreApp();
        this.request = this.CoreApp.request;
        this.page = {
            pageIndex: 1, // 當前頁數
            pageSize: 10, // 預設每頁筆數
            totalCount: 0, // 總筆數
            page_options: [5, 10, 20, 30, 40, 50, 100, 150, 200], // 下拉式顯示選單
        }
    }

    /**
     * 彙整發訊訊息
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} title 標題
     * @param {Object.<string, string>} response 回應資料
     */
    messageEvent(callback = {}, title = '', response = '') {
        if(response.data.message) {
            let status = response.data.isSuccess ? true : false;
            let result = { message: response.data.message, title: title };

            this.toast(async () => {}, result, status);
        }else {
            return;
        }
    }

    /**
     * 顯示更新錯誤提示
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} data 顯示資料
     * @param {Object.<string, string>} status
     */
    toast(callback = {}, data = {}, status = '') {
        let variant = status ? 'success' : 'danger';
        let noAutoHide = status ? false : true;
        this.vm.$bvToast.toast(data.message, {
            title: data.title,
            bodyClass: 'toast-body-class',
            headerClass: 'toast-header-class',
            variant,
            autoHideDelay: 5000,
            noAutoHide: noAutoHide
        });
    }

    /**
     * 登入後台
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 登入參數
     */
    authLogin(callback = {}, params = {}) {
        const options = {
            method: this.request.method.post,
            url: apiUrl.API_POST_AUTH_LOGIN,
            data: params,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch(async(err) => {
            callback(err.response);
        });
    }

    /**
     * 登出後台
     * @param {Object.<string, string>} callback
     */
    authLogout(callback = {}) {
        const options = {
            method: this.request.method.post,
            url: apiUrl.API_POST_AUTH_LOGOUT,
            is_loading: true,
            headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
        };
        axios(options).then((response) => {
            callback(response);
        }).catch(async(err) => {
            callback(err.response);
        });
    }

    /**
     * 更改密碼
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 修改參數
     */
    authUpdatePassword(callback = {}, params = {}) {
      const options = {
          method: this.request.method.post,
          url: apiUrl.API_POST_AUTH_UPDATE_PASSWORD,
          data: params,
          is_loading: true,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch(async(err) => {
          callback(err.response);
      });
    }

    /**
     * 查詢帳號權限
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 查詢參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    getAdmin(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.get,
          url: `${apiUrl.API_GET_ADMIN}`,
          params: params,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }

    /**
     * 更新帳號權限
     * @param {Object.<string, string>} callback
     * @param {Object.<string, string>} params 更新參數
     * @param {Boolean} is_loading 是否有讀取轉圈動畫
     */
    updateAdmin(callback = {}, params = {}, is_loading = true) {
      const options = {
          method: this.request.method.put,
          url: `${apiUrl.API_PUT_ADMIN}/${params.id}`,
          data: params.permission,
          is_loading: is_loading,
          headers: { 'Content-Type': this.request.headers.contentType.appJsonUtf8 }
      };
      axios(options).then((response) => {
          callback(response);
      }).catch((err) => {
          callback(err.response);
      });
    }
}

export default baseApi;



// WEBPACK FOOTER //
// ./src/models/API/baseApi.js